<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    :hidden-keys="['status', 'name']"
    resource="licenserecords" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import {
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import FeatureSelector from '@/components/FeatureSelector'
import { billItems } from '@/utils/auth'
import { getStatusColumn } from '../utils'

export default {
  name: 'LicenseDetail',
  mixins: [WindowsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getCopyWithContentTableColumn({
          field: 'service_num',
          title: this.$t('scope.text_778'),
          message: (row) => row.service_num,
          hideField: true,
          slotCallback: (row) => {
            return row.service_num.split(',').map(item => <div>{item}</div>)
          },
        }),
        {
          field: 'licensee',
          title: this.$t('scope.text_318'),
          minWidth: 100,
          slots: {
            default: ({ row }, h) => {
              return [<list-body-cell-wrap copy row={row} field='licensee' title={row.licensee}>
                <a-button type="link" icon="filter" size="small" slot="appendActions" onClick={() => this.filterKey(row, 'licensee')} />
              </list-body-cell-wrap>]
            },
          },
        },
        {
          field: 'features',
          title: this.$t('scope.scene_type'),
          formatter: ({ cellValue }) => {
            if (!cellValue) return '-'
            return cellValue.includes('maintenance') ? this.$t('scope.technical_support') : this.$t('scope.auth')
          },
        },
        {
          field: 'used_for',
          title: this.$t('scope.text_779'),
          minWidth: 120,
          formatter: ({ cellValue }) => {
            const map = {
              test: this.$t('scope.commercial_evaluation'),
              community: this.$t('scope.community'),
              internal: this.$t('scope.internal_test'),
              commercial: this.$t('scope.commercial_license'),
            }
            return map[cellValue]
          },
        },
        {
          field: 'virt_arm_limit',
          title: this.$t('scope.licenses.virthost_arm.title'),
        },
        {
          field: 'limit',
          title: this.$t('scope.licenses.virthost.title'),
        },
        {
          field: 'server_limit',
          title: this.$t('scope.licenses.cmp_server.title'),
        },
        {
          field: 'cmp_host_limit',
          title: this.$t('scope.licenses.cmp_host.title'),
        },
        {
          field: 'baremetal_arm_limit',
          title: this.$t('scope.licenses.baremetal_arm.title'),
        },
        {
          field: 'baremetal_limit',
          title: this.$t('scope.licenses.baremetal.title'),
        },
        getTimeTableColumn({
          field: 'created_at',
          title: this.$t('op_4'),
        }),
        getTimeTableColumn({
          field: 'expire',
          title: this.$t('scope.text_780'),
          sortable: true,
        }),
        {
          field: 'licensor',
          title: this.$t('common_610'),
          slots: {
            default: ({ row }, h) => {
              return [<list-body-cell-wrap copy row={row} field='licensor' title={row.licensor}>
                <a-button type="link" icon="filter" size="small" slot="appendActions" onClick={() => this.filterKey(row, 'licensor')} />
              </list-body-cell-wrap>]
            },
          },
        },
        getStatusColumn(),
        getTimeTableColumn({
          field: 'cancelled_at',
          title: this.$t('scope.cancelled_time'),
        }),
        {
          field: 'cancelled_by_name',
          title: this.$t('scope.cancelled_user'),
          formatter: ({ row }) => {
            return row.cancelled_by_name || row.cancelled_by || '-'
          },
        },
        {
          field: 'cancelled_reason',
          title: this.$t('scope.cancelled_reason'),
          formatter: ({ row }) => {
            return row.cancelled_reason || '-'
          },
        },
        // {
        //   field: 'cancelled_at',
        //   title: this.$t('scope.cancelled_time'),

        // }
      ],
      extraInfo: [
        {
          title: this.$t('scope.text_132'),
          items: [],
          slots: {
            default: ({ row }) => {
              const initFeatures = row.features ? row.features.split(',') : []
              const billTargetItems = initFeatures.filter(key => billItems.includes(key))
              if (initFeatures.includes('bill')) {
                // 兼容旧版本license只签发bill情况
                if (!billTargetItems.length) {
                  initFeatures.push(...billItems)
                }
              }
              if (initFeatures.includes('monitor') && !initFeatures.includes('monitor_operation')) {
                initFeatures.push('monitor_operation')
              }
              if (initFeatures.includes('monitor_operation') && !initFeatures.includes('monitor')) {
                initFeatures.push('monitor')
              }
              return <FeatureSelector defaultItems={initFeatures} />
            },
          },
        },
      ],
    }
  },
}
</script>
